import { AlertTriangle } from "lucide-react";

const RED = "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300";
const AMBER = "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300";
const GREEN = "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300";
const BLUE = "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300";
const SLATE = "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300";

export const EVENT_META = {
    login: { label: "Login", cls: SLATE },
    login_failed: { label: "Failed login", cls: RED },
    password_change: { label: "Password changed", cls: AMBER },
    role_change: { label: "Role changed", cls: BLUE },
    suspended: { label: "Staff suspended", cls: RED },
    restored: { label: "Staff restored", cls: GREEN },
    portal_suspended: { label: "Portal suspended", cls: RED },
    portal_restored: { label: "Portal restored", cls: GREEN },
    admin_recovery: { label: "Admin recovery", cls: AMBER },
    "2fa_enabled": { label: "2-step turned on", cls: GREEN },
    "2fa_disabled": { label: "2-step turned off", cls: RED },
    "2fa_codes_regenerated": { label: "Backup codes renewed", cls: AMBER },
    "2fa_devices_revoked": { label: "Trusted devices cleared", cls: SLATE },
};

const REASONS = {
    wrong_password: "wrong password", unknown_account: "no such account", suspended: "account suspended",
    wrong_2fa_code: "wrong 2-step code", totp: "with authenticator code", backup_code: "with backup code",
    trusted_device: "trusted device",
};

export function SecurityEventRow({ e }) {
    const meta = EVENT_META[e.event] || { label: e.event, cls: SLATE };
    const self = e.actor_email && e.actor_email === e.target_email;
    return (
        <tr className={`border-t border-border ${e.burst ? "bg-red-50/60 dark:bg-red-950/20" : "hover:bg-secondary/20"}`}
            data-testid={`security-event-${e.id}`}>
            <td className="px-4 py-2.5 whitespace-nowrap text-xs tabular">{new Date(e.created_at).toLocaleString()}</td>
            <td className="px-4 py-2.5 whitespace-nowrap">
                <span className={`text-[10px] uppercase font-semibold px-2 py-0.5 rounded ${meta.cls}`}>{meta.label}</span>
                {e.burst && (
                    <span className="ml-2 inline-flex items-center gap-1 text-[10px] font-semibold text-red-700 dark:text-red-400"
                          data-testid="security-burst-badge">
                        <AlertTriangle className="w-3 h-3" />5+ in 1h
                    </span>
                )}
                {e.reason && <div className="text-[10px] text-muted-foreground mt-0.5">{REASONS[e.reason] || e.reason}</div>}
            </td>
            <td className="px-4 py-2.5 text-xs">{e.actor_email || "—"}</td>
            <td className="px-4 py-2.5 text-xs">{self ? <span className="text-muted-foreground">self</span> : (e.target_email || "—")}</td>
            <td className="px-4 py-2.5 text-xs font-mono">{e.ip || <span className="text-muted-foreground italic font-sans">not recorded</span>}</td>
            <td className="px-4 py-2.5 text-xs">{e.device || <span className="text-muted-foreground italic">not recorded</span>}</td>
        </tr>
    );
}
